module.exports = __webpack_public_path__ + "/images/cover-multi-bolso-iphone.7e03a6a.webp";